import axios from "axios"
import moment from "moment"
import { toast } from "react-toastify"
import { UrlApi } from "../Keys"

let loadingToast = null

const ToastLoading = (msj) => {
  loadingToast = toast.info(msj, {
    theme: "dark",
    position: "top-center",
    autoClose: false,
    hideProgressBar: false,
    closeOnClick: false,
    pauseOnHover: false,
    draggable: true,
    progress: undefined,
  })
}

const ToastSuccess = (msj) => {
  toast.success(msj, {
    theme: "dark",
    position: "top-center",
    autoClose: 2000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    onOpen: () => {
      if (loadingToast !== null) {
        toast.dismiss(loadingToast)
      }
    },
  })
}

const ToastError = (msj) => {
  toast.error(msj, {
    theme: "dark",
    position: "top-center",
    autoClose: 2000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    onOpen: () => {
      if (loadingToast !== null) {
        toast.dismiss(loadingToast)
      }
    },
  })
}

const dataInicial = {
  solicitud: [],
  getSolicitud: false,
  respuestaSolicitudDomicilio: "",
  estadoSolicitudDomicilio: "",
  estadoSolicitudEstadoCivil: "",
  respuestaSolicitudEstadoCivil: "",
  estadoSolicitudFamilia: "",
  respuestaSolicitudFamilia: "",
  estadoSolicitudEducacion: "",
  respuestaSolicitudEducacion: "",
  estadoSolicitudCuentaBancaria: "",
  respuestaSolicitudCuentaBancaria: "",
  estadoCargaAdjunto: "",
}

const CLEAR_SOLICITUD_INFO = "CLEAR_SOLICITUD_INFO"

const LOADING_MI_SOLICITUD = "LOADING_MI_SOLICITUD"
const MI_SOLICITUD = "MI_SOLICITUD"
const ERROR_MI_SOLICITUD = "ERROR_MI_SOLICITUD"

const NUEVA_SOLICITUD_DOMICILIO_LOADING = "NUEVA_SOLICITUD_DOMICILIO_LOADING"
const NUEVA_SOLICITUD_DOMICILIO_EXITO = "NUEVA_SOLICITUD_DOMICILIO_EXITO"
const NUEVA_SOLICITUD_DOMICILIO_ERROR = "NUEVA_SOLICITUD_DOMICILIO_ERROR"

const NUEVA_SOLICITUD_ESTADO_CIVIL_LOADING = "NUEVA_SOLICITUD_ESTADO_CIVIL_LOADING"
const NUEVA_SOLICITUD_ESTADO_CIVIL_EXITO = "NUEVA_SOLICITUD_ESTADO_CIVIL_EXITO"
const NUEVA_SOLICITUD_ESTADO_CIVIL_ERROR = "NUEVA_SOLICITUD_ESTADO_CIVIL_ERROR"

const NUEVA_SOLICITUD_FAMILIA_LOADING = "NUEVA_SOLICITUD_FAMILIA_LOADING"
const NUEVA_SOLICITUD_FAMILIA_EXITO = "NUEVA_SOLICITUD_FAMILIA_EXITO"
const NUEVA_SOLICITUD_FAMILIA_ERROR = "NUEVA_SOLICITUD_FAMILIA_ERROR"

const NUEVA_SOLICITUD_EDUCACION_LOADING = "NUEVA_SOLICITUD_EDUCACION_LOADING"
const NUEVA_SOLICITUD_EDUCACION_EXITO = "NUEVA_SOLICITUD_EDUCACION_EXITO"
const NUEVA_SOLICITUD_EDUCACION_ERROR = "NUEVA_SOLICITUD_EDUCACION_ERROR"

const NUEVA_SOLICITUD_CUENTA_BANCARIA_LOADING = "NUEVA_SOLICITUD_CUENTA_BANCARIA_LOADING"
const NUEVA_SOLICITUD_CUENTA_BANCARIA_EXITO = "NUEVA_SOLICITUD_CUENTA_BANCARIA_EXITO"
const NUEVA_SOLICITUD_CUENTA_BANCARIA_ERROR = "NUEVA_SOLICITUD_CUENTA_BANCARIA_ERROR"

const LOADING_ADJUNTO_SOLICITUD = "LOADING_ADJUNTO_SOLICITUD"
const ADJUNTO_SOLICITUD = "ADJUNTO_SOLICITUD"
const ERROR_ADJUNTO_SOLICITUD = "ERROR_ADJUNTO_SOLICITUD"

export default function solicitudesReducers(state = dataInicial, action) {
  switch (action.type) {
    case CLEAR_SOLICITUD_INFO:
      return { ...state, solicitud: [] }
    case LOADING_MI_SOLICITUD:
      return { ...state, getSolicitud: action.getSolicitud }
    case MI_SOLICITUD:
      return { ...state, solicitud: action.payload, getSolicitud: action.getSolicitud }
    case ERROR_MI_SOLICITUD:
      return { ...state, getSolicitud: action.getSolicitud }
    case NUEVA_SOLICITUD_DOMICILIO_LOADING:
      return { ...state, estadoSolicitudDomicilio: action.resultado }
    case NUEVA_SOLICITUD_DOMICILIO_EXITO:
      return { ...state, respuestaSolicitudDomicilio: action.payload, estadoSolicitudDomicilio: action.resultado }
    case NUEVA_SOLICITUD_DOMICILIO_ERROR:
      return { ...state, estadoSolicitudEstadoCivil: action.resultado }
    case NUEVA_SOLICITUD_ESTADO_CIVIL_LOADING:
      return { ...state, estadoSolicitudEstadoCivil: action.resultado }
    case NUEVA_SOLICITUD_ESTADO_CIVIL_EXITO:
      return { ...state, respuestaSolicitudEstadoCivil: action.payload, estadoSolicitudEstadoCivil: action.resultado }
    case NUEVA_SOLICITUD_ESTADO_CIVIL_ERROR:
      return { ...state, estadoSolicitudEstadoCivil: action.resultado }
    case NUEVA_SOLICITUD_FAMILIA_LOADING:
      return { ...state, estadoSolicitudFamilia: action.resultado }
    case NUEVA_SOLICITUD_FAMILIA_EXITO:
      return { ...state, respuestaSolicitudFamilia: action.payload, estadoSolicitudFamilia: action.resultado }
    case NUEVA_SOLICITUD_FAMILIA_ERROR:
      return { ...state, estadoSolicitudFamilia: action.resultado }
    case NUEVA_SOLICITUD_EDUCACION_LOADING:
      return { ...state, estadoSolicitudEducacion: action.resultado }
    case NUEVA_SOLICITUD_EDUCACION_EXITO:
      return { ...state, respuestaSolicitudEducacion: action.payload, estadoSolicitudEducacion: action.resultado }
    case NUEVA_SOLICITUD_EDUCACION_ERROR:
      return { ...state, estadoSolicitudEducacion: action.resultado }
    case NUEVA_SOLICITUD_CUENTA_BANCARIA_LOADING:
      return { ...state, estadoSolicitudCuentaBancaria: action.resultado }
    case NUEVA_SOLICITUD_CUENTA_BANCARIA_EXITO:
      return {
        ...state,
        respuestaSolicitudCuentaBancaria: action.payload,
        estadoSolicitudCuentaBancaria: action.resultado,
      }
    case NUEVA_SOLICITUD_CUENTA_BANCARIA_ERROR:
      return { ...state, estadoSolicitudCuentaBancaria: action.resultado }
    case LOADING_ADJUNTO_SOLICITUD:
      return { ...state, estadoCargaAdjunto: action.resultado }
    case ADJUNTO_SOLICITUD:
      return { ...state, estadoCargaAdjunto: action.resultado }
    case ERROR_ADJUNTO_SOLICITUD:
      return { ...state, estadoCargaAdjunto: action.resultado }
    default:
      return { ...state }
  }
}

export const clearSolicitudInfo = () => async (dispatch) => {
  dispatch({
    type: CLEAR_SOLICITUD_INFO,
  })
}

export const miSolicitudCambioDomicilio = (token, empleadoID) => async (dispatch) => {
  dispatch({
    type: LOADING_MI_SOLICITUD,
    getSolicitud: false,
  })

  try {
    var entidad = "new_solicitudcambiodedomicilios"
    var fetch =
      "<entity name='new_solicitudcambiodedomicilio'>" +
      "<attribute name='createdon' />" +
      "<attribute name='new_fechasolicitud' />" +
      "<attribute name='new_fechavigencia' />" +
      "<attribute name='new_empleado' />" +
      "<attribute name='new_solicitudcambiodedomicilioid' />" +
      "<attribute name='new_name' />" +
      "<attribute name='new_estadosolicitud' />" +
      "<attribute name='statecode' />" +
      "<attribute name='statuscode' />" +
      "<order attribute='createdon' descending='false' />" +
      "<filter type='and'>" +
      "<condition attribute='new_empleado' operator='eq' uitype='new_empleado' value='" +
      empleadoID +
      "' />" +
      "</filter>" +
      "</entity>";

    const response = await axios.post(
      `${UrlApi}api/consultafetch`,
      {
        entidad: entidad,
        fetch: fetch,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
    dispatch({
      type: MI_SOLICITUD,
      payload: response.data,
      getSolicitud: true,
    })
  } catch (error) {
    console.log(error)
    dispatch({
      type: ERROR_MI_SOLICITUD,
      getSolicitud: true,
    })
  }
}

export const miSolicitudCambioEstadoCivil = (token, empleadoID) => async (dispatch) => {
  dispatch({
    type: LOADING_MI_SOLICITUD,
    getSolicitud: false,
  })

  try {
    var entidad = "new_solicitudcambioestadocivils"
    var fetch =
      "<entity name='new_solicitudcambioestadocivil'>" +
      "<attribute name='createdon' />" +
      "<attribute name='new_fechasolicitud' />" +
      "<attribute name='new_empleado' />" +
      "<attribute name='new_solicitudcambioestadocivilid' />" +
      "<attribute name='new_name' />" +
      "<attribute name='new_estadosolicitud' />" +
      "<attribute name='statecode' />" +
      "<attribute name='statuscode' />" +
      "<order attribute='createdon' descending='false' />" +
      "<filter type='and'>" +
      "<condition attribute='new_empleado' operator='eq' uitype='new_empleado' value='" +
      empleadoID +
      "' />" +
      "</filter>" +
      "</entity>"

    const response = await axios.post(
      `${UrlApi}api/consultafetch`,
      {
        entidad: entidad,
        fetch: fetch,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
    dispatch({
      type: MI_SOLICITUD,
      payload: response.data,
      getSolicitud: true,
    })
  } catch (error) {
    console.log(error)
    dispatch({
      type: ERROR_MI_SOLICITUD,
      getSolicitud: true,
    })
  }
}

export const miSolicitudActualizacionFamiliar = (token, empleadoID) => async (dispatch) => {
  dispatch({
    type: LOADING_MI_SOLICITUD,
    getSolicitud: false,
  })

  try {
    var entidad = "new_solicitudaltafamiliars"
    var fetch =
      "<entity name='new_solicitudaltafamiliar'>" +
      "<attribute name='createdon' />" +
      "<attribute name='new_fechasolicitud' />" +
      "<attribute name='new_empleado' />" +
      "<attribute name='new_solicitudaltafamiliarid' />" +
      "<attribute name='new_name' />" +
      "<attribute name='new_estadosolicitud' />" +
      "<attribute name='statecode' />" +
      "<attribute name='statuscode' />" +
      "<order attribute='createdon' descending='false' />" +
      "<filter type='and'>" +
      "<condition attribute='new_empleado' operator='eq' uitype='new_empleado' value='" +
      empleadoID +
      "' />" +
      "</filter>" +
      "</entity>"

    const response = await axios.post(
      `${UrlApi}api/consultafetch`,
      {
        entidad: entidad,
        fetch: fetch,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
    dispatch({
      type: MI_SOLICITUD,
      payload: response.data,
      getSolicitud: true,
    })
  } catch (error) {
    console.log(error)
    dispatch({
      type: ERROR_MI_SOLICITUD,
      getSolicitud: true,
    })
  }
}

export const miSolicitudActualizacionEducacion = (token, empleadoID) => async (dispatch) => {
  dispatch({
    type: LOADING_MI_SOLICITUD,
    getSolicitud: false,
  })

  try {
    var entidad = "new_solicitudaltadeeducacionformals"
    var fetch =
      "<entity name='new_solicitudaltadeeducacionformal'>" +
      "<attribute name='createdon' />" +
      "<attribute name='new_fechasolicitud' />" +
      "<attribute name='new_empleado' />" +
      "<attribute name='new_solicitudaltadeeducacionformalid' />" +
      "<attribute name='new_name' />" +
      "<attribute name='new_estadosolicitud' />" +
      "<attribute name='statecode' />" +
      "<attribute name='statuscode' />" +
      "<order attribute='createdon' descending='false' />" +
      "<filter type='and'>" +
      "<condition attribute='new_empleado' operator='eq' uitype='new_empleado' value='" +
      empleadoID +
      "' />" +
      "</filter>" +
      "</entity>"

    const response = await axios.post(
      `${UrlApi}api/consultafetch`,
      {
        entidad: entidad,
        fetch: fetch,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
    dispatch({
      type: MI_SOLICITUD,
      payload: response.data,
      getSolicitud: true,
    })
  } catch (error) {
    console.log(error)
    dispatch({
      type: ERROR_MI_SOLICITUD,
      getSolicitud: true,
    })
  }
}

export const miSolicitudActualizacionCuentaBancaria = (token, empleadoID) => async (dispatch) => {
  dispatch({
    type: LOADING_MI_SOLICITUD,
    getSolicitud: false,
  })

  try {
    var entidad = "new_solicitudaltacuentabancarias"
    var fetch =
      "<entity name='new_solicitudaltacuentabancaria'>" +
      "<attribute name='createdon' />" +
      "<attribute name='new_fechasolicitud' />" +
      "<attribute name='new_empleado' />" +
      "<attribute name='new_solicitudaltacuentabancariaid' />" +
      "<attribute name='new_name' />" +
      "<attribute name='new_estadosolicitud' />" +
      "<attribute name='statecode' />" +
      "<attribute name='statuscode' />" +
      "<order attribute='createdon' descending='false' />" +
      "<filter type='and'>" +
      "<condition attribute='new_empleado' operator='eq' uitype='new_empleado' value='" +
      empleadoID +
      "' />" +
      "</filter>" +
      "</entity>"

    const response = await axios.post(
      `${UrlApi}api/consultafetch`,
      {
        entidad: entidad,
        fetch: fetch,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
    dispatch({
      type: MI_SOLICITUD,
      payload: response.data,
      getSolicitud: true,
    })
  } catch (error) {
    console.log(error)
    dispatch({
      type: ERROR_MI_SOLICITUD,
      getSolicitud: true,
    })
  }
}

export const solucitudActualizacionDomicilio = (token, datos) => (dispatch) => {
  dispatch({
    type: NUEVA_SOLICITUD_DOMICILIO_LOADING,
    resultado: "LOADING",
  });
  ToastLoading("Procesando...")
  return new Promise((resolve, reject) => {
    if (Object.keys(datos).length > 0 && token) {
      axios.post(`${UrlApi}api/hrfactors/solicituddomicilio`,
        {
          "new_empleado": datos.empleado,
          "new_name": datos.asunto,
          "new_fechasolicitud": datos.fechaSolicitud ? moment(datos.fechaSolicitud).format('YYYY-MM-DD') : "",
          "new_fechavigencia": datos.fechaVigencia ? moment(datos.fechaVigencia).format('YYYY-MM-DD') : "",
          "new_calle": datos.calle,
          "new_nro": datos.nro,
          "new_depto": datos.depto,
          "new_piso": datos.piso,
          "new_barrio": datos.barrio,
          "new_localidad": datos.localidad.value,
          "new_provincia": datos.provincia.value,
          "new_pais": datos.pais.value,
          "new_estadosolicitud": 0
        }, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => {
          dispatch({
            type: NUEVA_SOLICITUD_DOMICILIO_EXITO,
            resultado: "EXITO",
            payload: response.data,
          });

          ToastSuccess("Actualización cargada con éxito");
          resolve(response.data);
        })
        .catch((error) => {
          console.log(error);

          dispatch({
            type: NUEVA_SOLICITUD_DOMICILIO_ERROR,
            resultado: "ERROR",
          });

          ToastError(error.response.data);
          reject(error);
        });
    }
  });
};


export const solucitudActualizacionEstadoCivil = (token, datos) => async (dispatch) => {
  dispatch({
    type: NUEVA_SOLICITUD_ESTADO_CIVIL_LOADING,
    resultado: "LOADING",
  });
  ToastLoading("Procesando...")

  return new Promise((resolve, reject) => {
    if (Object.keys(datos).length > 0 && token) {
      axios.post(`${UrlApi}api/hrfactors/estadocivil`,
        {
          "new_empleado": datos.empleado,
          "new_name": datos.asunto,
          "new_fechasolicitud": datos.fechaSolicitud ? moment(datos.fechaSolicitud).format('YYYY-MM-DD') : "",
          "new_estadocivil": datos.nuevoEstadoCivil ? Number(datos.nuevoEstadoCivil?.value) : 0,
          "new_estadosolicitud": 0,
        }, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => {
          dispatch({
            type: NUEVA_SOLICITUD_ESTADO_CIVIL_EXITO,
            resultado: "EXITO",
            payload: response.data,
          });

          ToastSuccess("Actualización cargada con éxito");
          resolve(response.data);
        })
        .catch((error) => {
          console.log(error);

          dispatch({
            type: NUEVA_SOLICITUD_ESTADO_CIVIL_ERROR,
            resultado: "ERROR",
          });

          ToastError(error.response.data);
          reject(error);
        });
    }
  });
};


export const solucitudActualizacionFamilia = (token, datos) => async (dispatch) => {
  dispatch({
    type: NUEVA_SOLICITUD_FAMILIA_LOADING,
    resultado: "LOADING",
  });
  ToastLoading("Procesando...")

  return new Promise((resolve, reject) => {
    if (Object.keys(datos).length > 0 && token) {
      axios.post(`${UrlApi}api/hrfactors/familiar`,
        {
          "new_empleado": datos.empleado,
          "new_name": datos.asunto,
          "new_fechasolicitud": datos.fechaSolicitud ? moment(datos.fechaSolicitud).format('YYYY-MM-DD') : "",
          "new_tipodocumento": datos.tipoDocumento ? Number(datos.tipoDocumento?.value) : 0,
          "new_nrodocumento": datos.nroDocumento,
          "new_apellidos": datos.apellidos,
          "new_nombredepila": datos.nombrePila,
          "new_fechanacimiento": datos.fechaNacimiento ? moment(datos.fechaNacimiento).format('YYYY-MM-DD') : "",
          "new_genero": datos.genero ? Number(datos.genero?.value) : 0,
          "new_edad": datos.edad ? Number(datos.edad) : 0,
          "new_cargadefamilia": datos.estaAcargo ? Number(datos.estaAcargo?.value) : 0,
          "new_parentesco": datos.parentesco ? datos.parentesco?.value : null,
        }, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => {
          dispatch({
            type: NUEVA_SOLICITUD_FAMILIA_EXITO,
            resultado: "EXITO",
            payload: response.data,
          });

          ToastSuccess("Actualización cargada con éxito");
          resolve(response.data);
        })
        .catch((error) => {
          console.log(error);

          dispatch({
            type: NUEVA_SOLICITUD_FAMILIA_ERROR,
            resultado: "ERROR",
          });

          ToastError(error.response.data);
          reject(error);
        });
    }
  });
};

export const solucitudActualizacionEducacion = (token, datos, empleadoid) => async (dispatch) => {

  return toast.promise(
    new Promise((resolve, reject) => {
      if (Object.keys(datos).length > 0 && token) {
        axios.post(`${UrlApi}api/hrfactors/educacionformal`,
          {
            "new_empleado": empleadoid,
            "new_name": datos.asunto,
            "new_titulo": datos.titulo ? datos.titulo : "",
            "new_universidad": datos.institucionOtorgante ? datos.institucionOtorgante.value : "",
            "new_tipodecarrera": datos.tipoCarrera ? Number(datos.tipoCarrera.value) : 0,
            "new_carrerasubdisciplinasconeau": datos.carreraSubdisciplina ? datos.carreraSubdisciplina?.value : "",
            "new_fechaingreso": datos.fechaIngreso ? moment(datos.fechaIngreso).format('YYYY-MM-DD') : "",
            "new_fechaegreso": datos.fechaEgreso ? moment(datos.fechaEgreso).format('YYYY-MM-DD') : "",
          }, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
          .then((response) => {
            dispatch({
              type: NUEVA_SOLICITUD_EDUCACION_EXITO,
              resultado: "EXITO",
              payload: response.data,
            });
            resolve(response.data);
          })
          .catch((error) => {
            console.log(error);

            dispatch({
              type: NUEVA_SOLICITUD_EDUCACION_ERROR,
              resultado: "ERROR",
            });
            reject(error);
          });
      }
    }),
    {
      pending: "Procesando...",
      success: "Solicitud creada con éxito!",
      error: {
        render({ data }) {
          return `${data}`;
        },
      },
    },
    {
      theme: "dark",
      position: "top-center",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    }
  )
};

export const solucitudActualizacionCuentaBancaria = (token, datos) => async (dispatch) => {
  dispatch({
    type: NUEVA_SOLICITUD_CUENTA_BANCARIA_LOADING,
    resultado: "LOADING",
  });
  ToastLoading("Procesando...")

  return new Promise((resolve, reject) => {
    if (Object.keys(datos).length > 0 && token) {
      axios.post(`${UrlApi}api/hrfactors/cuentabancaria`,
        {
          "new_empleado": datos.empleado,
          "new_name": datos.asunto,
          "new_fechasolicitud": datos.fechaSolicitud ? moment(datos.fechaSolicitud).format('YYYY-MM-DD') : "",
          "new_banco": datos.banco.value,
          "new_tipodecuenta": datos.tipoCuenta ? Number(datos.tipoCuenta.value) : 0,
          "new_numerocuenta": datos.nroCuenta,
          "new_cbu": datos.cbu,
          "new_formadepago": datos.formaPago ? Number(datos.formaPago.value) : 0,
        }, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => {
          dispatch({
            type: NUEVA_SOLICITUD_CUENTA_BANCARIA_EXITO,
            resultado: "EXITO",
            payload: response.data,
          });

          ToastSuccess("Actualización cargada con éxito");
          resolve(response.data);
        })
        .catch((error) => {
          console.log(error);

          dispatch({
            type: NUEVA_SOLICITUD_CUENTA_BANCARIA_ERROR,
            resultado: "ERROR",
          });

          ToastError(error.response.data);
          reject(error);
        });
    }
  });
};

export const cargarAdjuntoSolicitud = (token, file, solicitudId, tipoSolicitud) => async (dispatch) => {
  dispatch({
    type: LOADING_ADJUNTO_SOLICITUD,
    resultado: "LOADING",
  });
  try {
    let tipoDeSolicitud = `${tipoSolicitud}=${solicitudId}`
    const configDocumentos = {
      headers: {
        Authorization: `Bearer ${token}`,
        "content-type": "multipart/form-data",
      },
    };
    const response = await toast.promise(
      async () => {
        try {
          const response = await axios.post(`${UrlApi}api/aironeclick/adjuntosolicitud?${tipoDeSolicitud}`, file, configDocumentos);
          dispatch({
            type: ADJUNTO_SOLICITUD,
            resultado: "EXITO",
          });
          return response.data;
        } catch (error) {
          console.log(error)
          throw error;
        }
      },
      {
        pending: "Procesando...",
        success: "Archivo adjunto cargado con exito",
        error: {
          render({ data }) {
            return "Error al cargar el documento, ponganse en contacto con mesa de ayuda";
          },
        },
      },
      {
        theme: "dark",
        position: "top-center",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      }
    );
  } catch (error) {
    dispatch({
      type: ERROR_ADJUNTO_SOLICITUD,
      resultado: "ERROR",
    });
  }
};


